import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m18.327 20.042.863-.268.782-.425.68-.561.562-.681.425-.781.268-.864.093-.927V13.32l-.093-.927-.268-.864-.425-.781-.561-.68-.681-.563-.782-.424-.863-.268-.927-.093h-1.279v1.2H17.4l1.323.267 1.081.729.729 1.08.267 1.324v2.216l-.267 1.323-.729 1.081-1.08.729-1.324.267H6.6l-1.323-.267-1.081-.729-.729-1.08-.267-1.324V13.32l.267-1.324.729-1.08 1.08-.729L6.6 9.919h1.279v-1.2H6.6l-.927.093-.864.268-.781.424-.68.562-.562.68-.425.782-.268.864-.093.927v2.216l.093.927.268.864.425.781.561.68.681.562.781.425.864.268.927.093h10.8Z" }, null, -1),
    _createElementVNode("path", { d: "M11.4 14.273v-9.84h1.2v9.84z" }, null, -1),
    _createElementVNode("path", { d: "M8.602 7.225 11.6 3.49a.6.6 0 0 1 .944.01l2.863 3.736a.6.6 0 0 1-.952.73L11.59 4.23l.944.01-2.997 3.736a.6.6 0 0 1-.936-.75" }, null, -1)
  ]))]))
}
export default { render: render }